export default __webpack_public_path__ + "static/media/leadershipIcon.2e3b61c5.png";